var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.393 3.937c1.784 0 3.234 1.471 3.234 3.282 0 1.81-1.45 3.28-3.234 3.28-1.785 0-3.235-1.47-3.235-3.28 0-1.81 1.45-3.282 3.235-3.282zm3.696 9.375c1.527 0 2.772 1.263 2.772 2.813 0 0-.052 1.663-.683 2.303-.74.75-3.405 1.847-5.785 1.821-2.558-.028-5.302-1.708-6.107-2.785-.185-.247-.362-1.34-.362-1.34 0-1.55 1.245-2.812 2.772-2.812 2.455 0 1.944.469 3.697.469 1.758 0 1.238-.469 3.696-.469zM12.393 3c-2.296 0-4.159 1.89-4.159 4.219 0 2.329 1.863 4.218 4.159 4.218 2.295 0 4.158-1.89 4.158-4.218C16.55 4.889 14.688 3 12.393 3zm3.696 9.375c-2.668 0-2.05.468-3.696.468-1.64 0-1.031-.468-3.697-.468-2.041 0-3.696 1.678-3.696 3.75v.375c0 .29.09.841.321 1.285.183.35.603.643.965.964 0 0 2.41 2.21 6.107 2.25 3.588.04 5.785-1.607 5.785-1.607.346-.175.964-.643 1.286-1.285a3.203 3.203 0 00.321-1.286v-.697c0-2.07-1.654-3.75-3.696-3.75z",
    fill: "var(--color-secondary)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonIcon);
export default __webpack_public_path__ + "static/media/personIcon.dded4cc44b5f5c16a3193236f50636cb.svg";
export { ForwardRef as ReactComponent };